import path from 'ramda/src/path';
import {
  LOST,
  REJECTED,
  EXPIRED,
  WAGERED,
  CANCELLED,
  AVAILABLE,
  PENDING,
  WAGERING,
} from '../constants/bonuses';
import { getEntityWithImageUrl } from './imagePath';

export const getEntityWithLowerCaseStatus = (entity) => ({
  ...entity,
  status: entity.status.toLowerCase(),
});

export const COINS_COUNT = 100;
export const convertCoinsToAmount = (coins) => {
  return typeof coins === 'number' ? coins / COINS_COUNT : coins;
};

/**
 * function should return value like '12 345 678,92'
 * @param {number | undefined} amount
 * @param {number} fractionDigits
 * @returns {string}
 */
export const formatToDisplay = (amount, fractionDigits = 2) => {
  return (
    amount?.toLocaleString(['ru-RU'], {
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    }) ?? ''
  );
};

export const getCampaignAmount = (campaign) => {
  const coins =
    campaign.status === AVAILABLE
      ? path(['triggerDetails', 'payload', 'maxBonusAmount'], campaign) // for campaigns in AVAILABLE status
      : path(['triggerDetails', 'payload', 'minDepositAmount'], campaign); // for campaigns in PENDING status

  return convertCoinsToAmount(coins);
};

export const getBonusAmount = (bonus) => {
  return [EXPIRED, CANCELLED, REJECTED, LOST].includes(bonus.status)
    ? null
    : convertCoinsToAmount(bonus.originalBonusAmount);
};

export const getBonusProgress = (bonus) => {
  return parseInt(
    (bonus.currentWageringAmount / bonus.targetWageringAmount) * 100 // calculating progress based on the ratio of wagering to the target
  );
};

export const getRemainWageringAmount = (bonus) => {
  const coins = [PENDING, WAGERING].includes(bonus.status)
    ? bonus.targetWageringAmount - bonus.currentWageringAmount
    : null;
  return convertCoinsToAmount(coins);
};

export const getBonusExpirationTime = (bonus) => {
  return [WAGERED, CANCELLED, REJECTED, LOST].includes(bonus.status)
    ? bonus.lastUpdatedTime
    : bonus.expirationTime;
};

// Decorator for Bonuses and Campaigns content

export const getBonusContentEntity = (entity, contentAPIPrefix) => ({
  id: entity.external_id,
  title: entity.title,
  description: entity.description,
  shortDescription: entity.short_description,
  terms: entity.terms,
  image: entity.image,
  buttons: entity.buttons,
  categories: entity.categories.map((item) =>
    getEntityWithImageUrl(item, contentAPIPrefix, 'icon')
  ),
  wager: entity.wager,
});

// Decorators for UI

export const getUIEntityFromCampaign = (campaign) => ({
  ...campaign,
  id: campaign.id,
  image: campaign.image,
  title: campaign.title,
  status: campaign.status,
  expirationTime: campaign.endTime,
  progress: 0, // because the wagering has not started yet
  remainWageringAmount: null, // because the wagering has not started yet
  amount: getCampaignAmount(campaign),
  currency: path(['triggerDetails', 'payload', 'currency'], campaign),
  isCampaign: true,
  description: campaign.description,
  terms: campaign.terms,
});

export const getUIEntityFromBonus = (bonus) => ({
  ...bonus,
  id: bonus.id,
  title: bonus.title,
  status: bonus.status,
  campaignId: bonus.campaignId,
  expirationTime: getBonusExpirationTime(bonus),
  progress: getBonusProgress(bonus),
  remainWageringAmount: getRemainWageringAmount(bonus),
  amount: getBonusAmount(bonus),
  currency: bonus.currency,
  isCampaign: false,
  description: bonus.description,
  terms: bonus.terms,
});

export const getCurrency = (bonus) => {
  return bonus.isCampaign
    ? bonus?.triggerDetails?.payload?.currency
    : bonus?.currency;
};
